(() => {
  const init = (root) => {
    if (!root || root.dataset.mrpReady === 'true') return;
    root.dataset.mrpReady = 'true';

    const slides = [...root.querySelectorAll('.mrp-gallery__slide')];
    const thumbs = [...root.querySelectorAll('[data-mrp-thumb]')];
    const showMedia = (index) => {
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.mrpThumb))));

    const form = root.querySelector('.mrp-form');
    const variantsNode = root.querySelector('[data-mrp-variants]');
    if (!form || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const selects = [...form.querySelectorAll('[data-mrp-option]')];
    const idInput = form.querySelector('[data-mrp-variant-id]');
    const price = root.querySelector('[data-mrp-price]');
    const add = form.querySelector('[data-mrp-add]');
    const addText = form.querySelector('[data-mrp-add-text]');

    const updateVariant = () => {
      const selected = selects.map((select) => select.value);
      selects.forEach((select, i) => {
        const label = root.querySelector(`[data-option-label="${i}"]`);
        if (label) label.textContent = select.value;
      });
      const variant = variants.find((item) => item.options.every((value, i) => value === selected[i]));
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = variant.price;
      add.disabled = !variant.available;
      addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_media_id) {
        const mediaIndex = slides.findIndex((slide) => Number(slide.dataset.mediaId) === variant.featured_media_id);
        if (mediaIndex >= 0) showMedia(mediaIndex);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    selects.forEach((select) => select.addEventListener('change', updateVariant));

    const qty = form.querySelector('input[name="quantity"]');
    form.querySelector('[data-mrp-qty-minus]')?.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value || 1) - 1));
    form.querySelector('[data-mrp-qty-plus]')?.addEventListener('click', () => qty.value = Number(qty.value || 1) + 1);
  };

  document.querySelectorAll('[data-mrp-product]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-mrp-product]')));
})();
